import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'

import { MBOOK_ORGANISATIONS, strings } from '@constants'
import { getBillingAddressesApi } from '@data'
import { showLoader, showToast } from '@data/state/action'
import { toggleDrawer } from '@data/state/action/root'
import { DrawerBodyWrapper, DrawerFooterWrapper, EmptyState, TOAST_TYPE } from '@base'
import { Button, Select } from '@baseV2'
import GSTAddressCardV2 from '@pages/Admin/Enquiry/ManageEnquiries/ManageEnquiry/SelectGst/GSTAddressCardV2'
import { Spacings } from '@styles'

const BodyWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_4B};
`

const AddressListWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_2B};
`

const MbookGstSelection = ({
	organisations = MBOOK_ORGANISATIONS,
	organisation: initialOrganisation,
	selectedAddressId,
	submitCallback,
	submitLabel = strings('submit'),
}) => {
	const dispatch = useDispatch()

	// the first organisation is picked by default, so its GSTs are listed right away
	const [organisation, setOrganisation] = useState(initialOrganisation ?? organisations?.[0] ?? {})
	const [addresses, setAddresses] = useState([])
	const [address, setAddress] = useState(null)
	const [loading, setLoading] = useState(false)

	const orgId = organisation?.organisation_id

	// the GSTs belong to the picked organisation, so switching it drops the fetched list and the selection
	useEffect(() => {
		setAddresses([])
		setAddress(null)
		if (!orgId) return

		let active = true
		setLoading(true)
		dispatch(showLoader(true))
		getBillingAddressesApi(orgId)
			.then((response) => {
				if (active) setAddresses(response ?? [])
			})
			.catch((error) => {
				if (!active) return
				setAddresses([])
				dispatch(showToast(true, error?.response?.data?.message ?? strings('something_went_wrong'), { type: TOAST_TYPE.ERROR }))
			})
			.finally(() => {
				dispatch(showLoader(false))
				if (active) setLoading(false)
			})

		return () => {
			active = false
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [orgId])

	const submitHandler = () => {
		submitCallback?.({ ...address, trade_name: address?.trade_name ?? organisation?.organisation_name }, organisation)
		dispatch(toggleDrawer(false))
	}

	return (
		<>
			<DrawerBodyWrapper>
				<BodyWrapper>
					<Select
						id='mbook-gst-organisation'
						label={strings('organisation')}
						placeholder={strings(['select', 'organisation'])}
						data={organisations}
						displayKey='organisation_name'
						primaryKey='organisation_id'
						value={organisation}
						onChange={setOrganisation}
					/>
					{!!orgId &&
						!loading &&
						(addresses?.length ? (
							<AddressListWrapper>
								{addresses.map((item, index) => (
									<div onClick={() => setAddress(item)} key={item?.address?.address_id ?? index}>
										<GSTAddressCardV2
											gst={item?.gst}
											address={item?.address}
											selected={
												address
													? item?.address?.address_id === address?.address?.address_id
													: !!selectedAddressId && item?.address?.address_id === selectedAddressId
											}
										/>
									</div>
								))}
							</AddressListWrapper>
						) : (
							<EmptyState noAction text={strings('no_address_found')} />
						))}
				</BodyWrapper>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper>
				<Button color='primary' disabled={!address} onClick={submitHandler}>
					{submitLabel}
				</Button>
			</DrawerFooterWrapper>
		</>
	)
}

export default MbookGstSelection
